import { BasketStatus } from '@generated/gql/graphql';

import { isCbcMissingRequirementsException } from './utils';

const yourDetailsValidator = (status: BasketStatus) => {
  if (
    status.isValidSelection ||
    isCbcMissingRequirementsException(status.unavailableStatuses)
  ) {
    return true;
  }

  return false;
};

export { yourDetailsValidator };
